export default __webpack_public_path__ + "static/media/pt.90bff567.svg";